import Inputmask from "inputmask/lib/inputmask";

export const ModelPhone = {
    twoWay: true,

    bind: function (el, binding, vnode) {
        const elementMask = el.getAttribute('mask');
        const elementPlaceholder = el.getAttribute('placeholder');

        Inputmask({
            greedy: false,

            mask: () => {
                return elementMask
                    || '+7(###)###-##-##';
            },

            placeholder: elementPlaceholder || '_',

            definitions: {
                '#': {
                    validator:        "[0-9]",
                    cardinality:      1,
                    definitionSymbol: "*"
                },
                '*': {
                    validator: "[0-9A-Za-z_\-]",
                }
            },

            showMaskOnHover: true,
        }).mask(el);
        el.addEventListener('change', function(event) {
            _.set(vnode.context, binding.expression,event.target.value);
        });
        el.addEventListener('change', function(event) {
            _.set(vnode.context, binding.expression,event.target.value);
        });
    },
    update: function(el, binding) {
        if (binding.value !== undefined){
            el.value = binding.value;
        }

    },
};
